import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { captureAdsParams, pushPageView } from '../../utils/adsTracking';

// Dispara um page_view no dataLayer a cada troca de rota do SPA e
// persiste gclid/UTMs. No GTM, use o evento "page_view" como gatilho
// (Evento personalizado) das tags de Google Ads / remarketing / GA4.
// O link de redefinição de senha traz o token em ?code=; ele não pode ir para o analytics
const sanitizeSearch = (pathname, search) => {
  if (pathname !== '/redefinir-senha') return search;
  const params = new URLSearchParams(search);
  params.delete('code');
  const clean = params.toString();
  return clean ? `?${clean}` : '';
};

const RouteTracker = () => {
  const { pathname, search: rawSearch } = useLocation();
  const search = sanitizeSearch(pathname, rawSearch);

  useEffect(() => {
    captureAdsParams(search);
    // espera o Helmet atualizar o título antes de enviar o evento
    const id = setTimeout(() => pushPageView({ pathname, search }), 0);
    return () => clearTimeout(id);
  }, [pathname, search]);

  return null;
};

export default RouteTracker;
